export const PATH_PAGE = {
  client: {
    root: getClientPath(),
    detail: getClientPath("/detail")
  },
  asset: {
    detail: getAssetPath("/detail")
  },
  estimation: {
    root: getEstimationPath(),
    detail: getEstimationPath("/detail"),
    pricing: getEstimationPath("/pricing"),
    pricingDetail: getEstimationPath("/pricing/pricing-detail")
  },
  contracts: {
    root: getContractPath(),
    detail: getContractPath("/detail"),
    milestones: getContractPath("/milestone"),
    milestoneDetail: getContractPath("/milestone/milestone-detail"),
    purchaseOrder: getContractPath("/purchase-order"),
    purchaseOrderDetail: getContractPath(
      "/purchase-order/purchase-order-detail"
    )
  },
  allocation: {
    root: getallocationPath(),
    detail: getallocationPath("/detail")
  },
  invoicing: {
    root: getInvoicingPath()
  },
  insights: {
    root: getInsightsPath()
  },

  resourcesManagement: {
    root: getResourcesManagementPath(),
    detail: getResourcesManagementPath("/resources/details"),
    utilization: getResourcesManagementPath("/utilization"),
    insights: getResourcesManagementPath("/insights"),
    consultants: getResourcesManagementPath("/consultants")
  },
  exportTimesheetManagement: {
    root: getExportTimesheetManagementPath()
  },
  timesheetManagement: {
    root: getTimesheetMangmentPath(),
    timesheetOverview: getTimesheetMangmentPath("/overview"),
    empTimesheetOverview: getTimesheetMangmentPath("/empTimesheet"),
    managerView: getTimesheetMangmentPath("/manager_view"),
    ongoinProjectTimesheetList: getTimesheetMangmentPath(
      "/empTimesheet/ongoingProject"
    ),
    empTimesheetTotalHrs: getTimesheetMangmentPath(
      "/empTimesheet/ongoingProject/totalHrscount"
    ),
    missingTimesheets: getTimesheetMangmentPath(
      "/empTimesheet/missingTimesheets"
    )
  },
  dashboardPage: {
    root: getDashBoardPath()
  },
  rateCard: {
    root: getRateCardPath(),
    details: getRateCardPath("/details/:id")
  },
  setting: {
    root: settingPath(),
    skillPayrateConfigList: settingPath("/skill-payrate-config"),
    skillPayrateDetails: settingPath("/skill-payrate-config/details"),
    customeraccess: settingPath("/customer-access"),
    customerdeatil: settingPath("/customer-access/details"),
    employee: settingPath("/employee"),
    asset: settingPath("/asset"),
    employeeDetail: settingPath("/employee/details"),
    invoiceSettings: settingPath("/invoice-settings")
  },
  dashboard: "/dashboard",
  contractList: "/contract-list",
  budget: "/budget",
  login: "/login",
  page404: "/404",
  pageRoles: "/roles",
  pageSettings: "/settings",
  pageInvoicing: getClientPath("/invoicing"),
  permissionDenied: "/permissionDenied"
};

function getClientPath(path) {
  return "/client" + (path ?? "");
}
function getAssetPath(path) {
  return "/asset" + (path ?? "");
}

function getEstimationPath(path) {
  return getClientPath() + "/estimation" + (path ?? "");
}

function getContractPath(path) {
  return getClientPath() + "/contracts" + (path ?? "");
}

function getallocationPath(path) {
  return getClientPath() + "/allocations" + (path ?? "");
}

function getResourcesManagementPath(path) {
  return "/resources" + (path ?? "");
}
function getExportTimesheetManagementPath(path) {
  return "/exportTimesheet" + (path ?? "");
}

function getInvoicingPath(path) {
  return getClientPath() + "/invoices" + (path ?? "");
}

function getInsightsPath(path) {
  return getClientPath() + "/insights" + (path ?? "");
}
function getDashBoardPath(path) {
  return "/dashboardpage" + (path ?? "");
}
function getRateCardPath(path) {
  return "/rateCard" + (path ?? "");
}
function settingPath(path) {
  return "/setting" + (path ?? "");
}
function getTimesheetMangmentPath(path) {
  return "/timesheet" + (path ?? "");
}
